import { AfterViewInit, Component, ElementRef, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-disclaimer',
  templateUrl: './disclaimer.component.html',
  styleUrls: ['./disclaimer.component.scss']
})
export class DisclaimerComponent implements OnInit, AfterViewInit {
  descrizioneSezione='';
  titoloSezione=''
  tipoSezione = 0;

  constructor(
    private modalService: NgbModal,
        private route: ActivatedRoute,
        private _sanitizer: DomSanitizer,
        private router: Router,
        private elRef: ElementRef
  ) { 
    this.route.params.subscribe(params => {

      if (params['mod'] == "cookies") {
        this.tipoSezione= 1;
      } else if(params['mod'] == "privacy"){
        this.tipoSezione= 2;
      } else {
        this.router.navigate(['/404']);
      }
    });
  }

  
  ngAfterViewInit() {
    this.route.fragment.subscribe(fragment => {
      if (fragment) {
        const element = this.elRef.nativeElement.querySelector(`#${fragment}`);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    });
  }

  ngOnInit(): void {
  }

  scrollToSection(fragment: string) {
    const element = this.elRef.nativeElement.querySelector(`#${fragment}`);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  routeTo(path: any) {
    this.router.navigate([path]);
  }


}
